module.exports = __webpack_public_path__ + "static/media/modulo-comercial.2e93ded9.svg";